import { render, staticRenderFns } from "./ListRecepcionistsAdmin.vue?vue&type=template&id=2fb2fe3a&scoped=true&"
import script from "./ListRecepcionistsAdmin.vue?vue&type=script&lang=ts&"
export * from "./ListRecepcionistsAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./ListRecepcionistsAdmin.vue?vue&type=style&index=0&id=2fb2fe3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2fe3a",
  null
  
)

export default component.exports